import {useContext, useMemo} from 'react'
import {Dropdown} from '@components/lib'

import I18nContext from 'contexts/I18nContext'

import {languageMap} from './LanguagesDropdown.config'

const LanguagesDropdown = ({...rest}) => {
  const {language, languages, changeLanguage} = useContext(I18nContext)
  const dropdownItems = useMemo(() => languages.map(l => languageMap[l]), [languages])
  return (
    <Dropdown
      text={languageMap[language]?.textShort}
      selectedId={language}
      items={dropdownItems}
      onSelect={changeLanguage}
      size='sm'
      {...rest}
    />
  )
}

export default LanguagesDropdown
